export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18 11a4 4 0 012.5 7.121v3.438a.25.25 0 01-.378.213l-1.994-1.195a.25.25 0 00-.256 0l-1.994 1.195a.25.25 0 01-.377-.213V18.12A4 4 0 0118 11zm0 2a2 2 0 100 4 2 2 0 000-4z\" fill=\"#7B61FF\"/><path d=\"M18.88 2.508a1 1 0 01.765 1.44c-.29.578-.468 1.456-.56 2.442-.091.96-.092 1.919-.085 2.6l-2 .02a27.388 27.388 0 01.093-2.808c.052-.549.134-1.135.266-1.702H5.76c-.675 2.673-.36 4.808.038 7.145.388 2.27.854 4.733.396 7.855h7.305v2H5a1 1 0 01-.977-1.21c.705-3.29.243-5.74-.195-8.31-.442-2.586-.856-5.286.217-8.774A1 1 0 015 2.5h13.75l.13.008z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};